import { NgModule } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { initialIntercomState } from './intercom-state';
import { reducer } from './intercom-reducer';
import { EffectsModule } from '@ngrx/effects';
import { IntercomEffects } from './intercom-effects';
import { combineReducers } from '@core/utils/state';

@NgModule({
    imports: [
      StoreModule.forFeature(StateSlice.INTERCOM, (reducer as ActionReducer<any, any>), {
        initialState: initialIntercomState,
        reducerFactory: combineReducers
      }),
      EffectsModule.forFeature([ IntercomEffects ])
    ]
})
export class IntercomStateModule {}
